import { type ComponentProps } from "react";

const PaiementIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg 
    width="25" 
    height="31" 
    viewBox="0 0 25 31" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}>

<path d="M14.2578 0C15.1069 7.36508e-05 15.9239 0.327722 16.5371 0.915039L23.9844 8.05273C24.6327 8.67402 24.9999 9.53372 25 10.4316V27.7129C24.9999 29.5323 23.5245 31.0068 21.7051 31.0068H3.29395C1.47474 31.0065 8.04016e-05 29.5322 0 27.7129V3.29395C0.000355766 1.47491 1.47491 0.000338381 3.29395 0H14.2578ZM4.65137 24.6123H20.1553V21.124H4.65137V24.6123ZM4.65137 19.1865H20.1553V15.6973H4.65137V19.1865ZM14.6152 2.79395C14.3711 2.54981 13.9533 2.72219 13.9531 3.06738V10.4648C13.9531 10.6788 14.1269 10.8524 14.3408 10.8525H21.7383C22.0835 10.8525 22.2567 10.4356 22.0127 10.1914L14.6152 2.79395Z" fill="#1C1B26"/>
</svg>
  
);
};

export default PaiementIcon;